<style>
  input, select {
    flex: 1 1 auto;
    font-size: 0.9em;
    background-color: #fff;
    margin: 0.3em 0.4em 0.3em 0.2em; /* top | right | bottom | left */
    padding: 0.3em 0.3em 0.3em 0.4em; /* top | right | bottom | left */
    text-align: left;
    width: auto;
    /*width: 17.4em;*/
    box-sizing: border-box;
  }
  select {
    padding: 0.25em 0.3em 0.25em 0.15em; /* top | right | bottom | left */
  }
  .input_invalid {
    background-color: #fcc;
  }
  .readonly {
    background-color: #ddd;
  }
</style>

<script>
  import { afterUpdate, onMount } from 'svelte';
  import config from '../../config';
  import { 
    auth_user, lang,
    prof_edit, prof_edit_mode,
  } from '../store';
  import util from '../util';
    
  function input_keypress(keyboard_event) {
    if (keyboard_event.key === 'Enter') {
      validate();
      if ($prof_edit.input_valid) {
        $prof_edit.edit_save();
      }
    } else if (keyboard_event.key === 'Escape') {
      $prof_edit.edit_cancel();
    } else {
      
    }
  }
  function validate() {
    if (value_valid(value_edit)) {
      $prof_edit.result[item_type] = value_edit;
      $prof_edit.validation[item_type] = true;
      input_invalid = false;
    } else {
      $prof_edit.validation[item_type] = false;
      input_invalid = true;
    }
    let is_valid = true;
    for (const [key, value] of Object.entries($prof_edit.validation)) {
      if (value === false) {
        is_valid = false;
        break;
      }
    }
    if (is_valid) {
      $prof_edit.input_valid = true;
    } else {
      $prof_edit.input_valid = false;
    }
  }
  function value_valid(value) {
    if (input_params.values) {
      if (input_params.values.includes(value)) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        value.length >= input_params.min_len
        && value.length <= input_params.max_len
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
  
  afterUpdate(() => {
    if (input) {
      if (input_params.default && !$prof_edit.input_selected_once) {
        input.focus();
        input.select();
        $prof_edit.input_selected_once = true;
      };
      validate();
    }
  });
  
  export let item_type;
    
  const input_params = config.input.profile[item_type];
  let input;
  let input_invalid = false;
  let value = $auth_user[item_type];
  if (!value) {
    value = '';
  }
  let value_edit = value;
  if (item_type === 'comp_admin') {
    if ($auth_user.comp_admin === $auth_user.user_id) {
      value = util.caption($lang, 'prof_item', 'admin_true');
    } else {
      value = util.caption($lang, 'prof_item', 'admin_false');
    }
  }
  let input_type = 'text';
  if (item_type === 'email') {
    input_type = 'email';
  } else if (item_type === 'phone') {
    input_type = 'tel';
  }
</script>

{#if $prof_edit_mode && input_params}
  {#if input_params.values}
    <select class:input_invalid bind:value={value_edit} on:blur={validate}>
    {#each input_params.values as select_value}
      <option value={select_value}>
        {util.caption($lang,`prof_${item_type}`,select_value)}
      </option>
    {/each}
    </select>
  {:else if input_type === 'email'}
    <input class:input_invalid type='email' minlength={input_params.min_len} maxlength={input_params.max_len} bind:this={input} bind:value={value_edit} on:keydown={input_keypress}>
  {:else if input_type === 'tel'}
    <input class:input_invalid type='tel' minlength={input_params.min_len} maxlength={input_params.max_len} bind:this={input} bind:value={value_edit} on:keydown={input_keypress}>
  {:else}
    <input class:input_invalid type='text' minlength={input_params.min_len} maxlength={input_params.max_len} bind:this={input} bind:value={value_edit} on:keydown={input_keypress}>
  {/if}
{:else if input_params && input_params.values}
  <input class='readonly' readonly='readonly' type={input_type} value={util.caption($lang,`prof_${item_type}`,value)}>
{:else}
  <input class='readonly' readonly='readonly' type={input_type} value={value}>
{/if}
